module.exports = __webpack_public_path__ + "static/media/translate.8e598994.svg";